<ion-card>
    <ion-card-content>
        <ion-item>
            <ion-label position="floating">Location</ion-label>
            <ion-select [(ngModel)]="document.location" interface="popover">
                <ion-select-option *ngFor="let depot of depots" [value]="depot.cod">{{depot.descr}}</ion-select-option>
            </ion-select>
        </ion-item>
    </ion-card-content>
</ion-card>
